import { triageAPI } from "../services/api";
import { collectClientContext } from "./clientContext";

const PAGE_VIEW_SESSION_KEY = "solvtax_tracked_page_views";

/**
 * Fire-and-forget site activity → API → Discord.
 * Never throws; safe to call from click handlers and effects.
 */
export const trackActivity = (payload) => {
  void triageAPI.trackActivity({
    ...payload,
    context: collectClientContext(),
  });
};

/**
 * Track a marketing/product page view once per browser session per path.
 */
export const trackPageViewOnce = (path, label) => {
  const normalized = path || "/";
  try {
    const raw = sessionStorage.getItem(PAGE_VIEW_SESSION_KEY);
    const seen = new Set(raw ? JSON.parse(raw) : []);
    if (seen.has(normalized)) return;
    seen.add(normalized);
    sessionStorage.setItem(PAGE_VIEW_SESSION_KEY, JSON.stringify([...seen]));
  } catch {
    // sessionStorage unavailable — still notify once this call
  }
  trackActivity({ event: "page_view", path: normalized, label });
};

export const trackPortalCta = (label) => {
  trackActivity({
    event: "portal_cta",
    path: typeof window !== "undefined" ? window.location.pathname : undefined,
    label,
  });
};
